import React, { useState } from "react";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { ProductShowcase } from "../components/ProductShowcase";
import { Principles } from "../components/Principles";
import { About } from "../components/About";
import { ContactSection } from "../components/ContactSection";
import { Footer } from "../components/Footer";

export const Home: React.FC = () => {
  const [selectedTopic, setSelectedTopic] = useState("general");

  const handleSelectZentrak = () => {
    setSelectedTopic("zentrak");
    const el = document.getElementById("contact");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-canvas text-ink selection:bg-plum selection:text-white">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <ProductShowcase onSelectZentrakInquiry={handleSelectZentrak} />
        <Principles />
        <About />
        <ContactSection
          selectedTopic={selectedTopic}
          onTopicChange={setSelectedTopic}
        />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
